import { render, staticRenderFns } from "./TPassMsg.vue?vue&type=template&id=702d2220&"
import script from "./TPassMsg.vue?vue&type=script&lang=js&"
export * from "./TPassMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports